//@flow
import { Dispatcher } from 'flux';

class NatureboxDispatcher extends Dispatcher {
  dispatch(payload:Object) {
    // if (!payload.action) {
    //   console.log('found an undefined action');
    //   console.dir(payload);
    //   var e = new Error('action');
    //   console.log(e.stack);
    // }
    super.dispatch(payload);
  }

  dispatchAction(action:string, data:any = {}, error:?Object = null) {
    this.dispatch({
      action, data, error,
    });
  }
}

export default (new NatureboxDispatcher():NatureboxDispatcher);
